// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".risk_title {\n  line-height: 30px;\n  color: rgb(16, 16, 16);\n  font-size: 16px;\n  margin-bottom: 18px;\n  font-weight: bold;\n}\n.risk_date {\n  line-height: 30px;\n  color: #606266;\n  font-size: 14px;\n  text-align: left;\n}\n.tick_text {\n  color: #606266;\n  font-size: 12px !important;\n}\n.fund_total_number {\n  line-height: 30px;\n  color: #606266;\n  font-size: 14px !important;\n}\n#riskTab .el-tabs__item {\n  color: #606266;\n}\n#riskTab .el-tabs__item.is-active {\n  color: #EF7621;\n}\n#riskTab .el-tabs__item:hover {\n  color: #EF7621;\n}\n#riskTab .el-tabs__active-bar {\n  background-color: #EF7621;\n}\n.risk_adjustment_item {\n  font-weight: bold;\n  font-size: 14px;\n  margin-top: 15px;\n}\n.risk_adjustment_data {\n  font-size: 14px;\n  margin-top: 15px;\n}\n#riskTab .el-tabs__header {\n  margin-bottom: 25px !important;\n}\n.mbc-vertical-bar-chart * {\n  shape-rendering: crispEdges !important;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"risk_title": "risk_title",
	"risk_date": "risk_date",
	"tick_text": "tick_text",
	"fund_total_number": "fund_total_number",
	"riskTab": "riskTab",
	"el-tabs__item": "el-tabs__item",
	"is-active": "is-active",
	"el-tabs__active-bar": "el-tabs__active-bar",
	"risk_adjustment_item": "risk_adjustment_item",
	"risk_adjustment_data": "risk_adjustment_data",
	"el-tabs__header": "el-tabs__header",
	"mbc-vertical-bar-chart": "mbc-vertical-bar-chart"
};
module.exports = ___CSS_LOADER_EXPORT___;
